"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.streams = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.streams = {
    "fr": "https://stream.fr.morow.com/morow_med.aacp",
    "ca": "https://stream.ca.morow.com/morow_med.aacp"
};
class MorowPlayer extends EventTarget {
    constructor(element) {
        super();
        this.url = null;
        this.setUrl = (url) => {
            this.url = url;
            const wasPlaying = this.isPlaying();
            this.stop();
            if (wasPlaying) {
                this.play();
            }
        };
        this.autoPlay = () => {
            if (this.player.src && js_cookie_1.default.get('stream-autoplay') == 'true') {
                this.play();
            }
        };
        this.play = () => {
            console.debug("play()");
            if (!this.url) {
                console.error("URL not defined");
                return;
            }
            this.player.src = this.url;
            this.player.play();
        };
        this.isPlaying = () => {
            console.debug("isPlaying(): " + (!this.player.paused ? 'yes' : 'no'));
            return !this.player.paused;
        };
        this.stop = () => {
            console.debug("stop()");
            this.player.currentTime = 0;
            this.player.pause();
        };
        this.player = element;
        this.player.addEventListener("abort", () => {
            console.debug("player event - abort");
        });
        this.player.addEventListener("canplay", () => {
            console.debug("player event - canplay");
        });
        this.player.addEventListener("canplaythrough", () => {
            console.debug("player event - canplaythrough");
        });
        this.player.addEventListener("durationchange", () => {
            console.debug("player event - durationchange");
        });
        this.player.addEventListener("emptied", () => {
            console.debug("player event - emptied");
        });
        this.player.addEventListener("ended", () => {
            console.debug("player event - ended");
        });
        this.player.addEventListener("error", () => {
            console.debug("player event - error");
            this.dispatchEvent(new Event('stop'));
        });
        this.player.addEventListener("loadeddata", () => {
            console.debug("player event - loadeddata");
        });
        this.player.addEventListener("loadedmetadata", () => {
            console.debug("player event - loadedmetadata");
        });
        this.player.addEventListener("loadstart", () => {
            console.debug("player event - loadstart");
            this.dispatchEvent(new Event('loading'));
        });
        this.player.addEventListener("pause", () => {
            console.debug("player event - pause");
            this.dispatchEvent(new Event('stop'));
        });
        this.player.addEventListener("play", () => {
            console.debug("player event - play");
            this.dispatchEvent(new Event('loading'));
        });
        this.player.addEventListener("playing", () => {
            console.debug("player event - playing");
            this.dispatchEvent(new Event('play'));
        });
        this.player.addEventListener("progress", () => {
            //console.debug("player event - progress");
        });
        this.player.addEventListener("ratechange", () => {
            console.debug("player event - ratechange");
        });
        this.player.addEventListener("seeked", () => {
            console.debug("player event - seeked");
        });
        this.player.addEventListener("seeking", () => {
            console.debug("player event - seeking");
        });
        this.player.addEventListener("stalled", () => {
            console.debug("player event - stalled");
        });
        this.player.addEventListener("suspend", () => {
            console.debug("player event - suspend");
            this.dispatchEvent(new Event('stop'));
        });
        this.player.addEventListener("timeupdate", () => {
            //console.debug("player event - timeupdate");
        });
        this.player.addEventListener("volumechange", () => {
            console.debug("player event - volumechange");
        });
        this.player.addEventListener("waiting", () => {
            console.debug("player event - waiting");
        });
    }
}
exports.default = MorowPlayer;
